export default function(inputDate) {
  if (inputDate === undefined) {
    return '';
  }

  const date = new Date(inputDate);

  // TODO use this too line as soon node support Internationalization correctly
  // const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false };
  // return date.toLocaleDateString('it-IT', options);

  const day = ('' + date.getDate()).padStart(2, '0');
  const month = ('' + (date.getMonth() + 1)).padStart(2, '0');
  const year = date.getFullYear();
  const hours = ('' + date.getHours()).padStart(2, '0');
  const minutes = ('' + date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
